import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SignatureBg } from "../components/SignatureBg";
import { useUser } from "../lib/auth";

export default function LoginPage() {
  const { login, user } = useUser();
  const loc = useLocation() as any;
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (user) {
    nav("/dashboard", { replace: true });
  }

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      await login(email, password);
      nav(loc.state?.from || "/dashboard", { replace: true });
    } catch (e: any) {
      setError(e?.message || "Invalid login");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-split">
      {/* Left: branded emerald visual panel — per the Alief brand kit's
          split-screen login direction. Hidden on small screens (form first). */}
      <aside className="login-visual has-signature-bg" aria-hidden="true">
        <SignatureBg />
        <div className="login-visual-inner">
          <img className="login-visual-logo" src="/brand-logo-stacked.png" alt="" />
          <p className="login-visual-tag">Get Qualified.&ensp;Get Matched.&ensp;Get Funded.</p>
          <ul className="login-visual-points">
            <li>Credit-report analysis &amp; funding readiness</li>
            <li>Lender matching from a live approval database</li>
            <li>Contracts, pipeline &amp; a branded client portal</li>
          </ul>
        </div>
      </aside>
      {/* Right: clean white/cream authentication panel. */}
      <div className="login-formside">
      <div className="login-card">
        {/* The full logo lives on the visual panel; the card keeps a clean
            text lockup so the mark never gets squeezed into a chip. */}
        <div className="brand-lockup login-brand">
          <div>
            <strong className="brand-wordmark">Alief Funding Hub</strong>
            <span>Powered by Alief Financial</span>
          </div>
        </div>
        <h1 id="login-heading">Staff sign-in</h1>
        <form onSubmit={submit} className="stacked-form" aria-labelledby="login-heading">
          <label className="form-field">
            <span>Email</span>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="form-field">
            <span>Password</span>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {error && <p className="error-text" role="alert">{error}</p>}
          <button className="primary-button wide-button" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <button type="button" className="link-button" style={{ marginTop: 4 }} onClick={() => nav("/forgot-password")}>
            Forgot your password?
          </button>
        </form>
      </div>
    </div>
      </div>
  );
}
